.buttonContainer {
    align-items: center;
}

@keyframes fade {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

.fadeIn {
    animation: fade 0.25s ease-in-out;
}

.round {
    border-radius: 16px;
    width: 32px;
    height: 32px;
    text-align: center;
    font-size: var(--mantine-font-size-lg);
    border: 0px solid var(--mantine-color-primary-3);
}
